const signalR = require("@microsoft/signalr")
import store from '../index';
export default {
    namespaced: true,
    state: {
        connection: null, // ws对象
        msg: null, //ws来消息存储
    },
    getters: {},
    mutations: {
        changgeConnection(state, obj) {
            state.connection = obj
        },
        changeMsg(state, obj) {
            state.msg = obj
            console.log(state.msg, "消息来了");
        },
    },
    actions: {
        //开始连接
        startInitSignalR({
            dispatch,
            state,
            commit
        }, obj) {
            const initConnection = () => {
                const connection = new signalR.HubConnectionBuilder()
                    .withUrl(
                        `${process.env.VUE_APP_Url_signalr_http}?UserId=${store.state.userInfo.uid}&CompanyId=${store.state.userInfo.companyId}&SystemId=${sessionStorage.getItem('systemId')}&ShopId=${store.state.shopId}&isStaff=1`, {}
                    )
                    .configureLogging(signalR.LogLevel.Debug)
                    .withAutomaticReconnect() //断开自动重连
                    .build()

                //修改ws连接对象
                commit('changgeConnection', connection)

                //错误打印
                state.connection.onclose = function (e) {
                    console.log(e, '错误webscoket');
                }

                // 之前的消息有 活体   预约 
                //绑定事件来消息会触发
                //发送给用户
                state.connection.on("SendToUsers", (userId, content) => {
                    console.log('用户消息来了');
                    commit('changeMsg', { userId, content })
                })
                //发送给门店系统  --只弹出消息
                state.connection.on("SendToShopSystem", (shopId, systemId, content) => {
                    console.log('门店系统消息来了');
                    commit('changeMsg', { shopId, systemId, content })
                })

                //发送给会员  --只弹出消息
                state.connection.on("SendToMember", (memberId, content) => {
                    console.log('会员消息来了');
                    commit('changeMsg', { memberId, content })
                })
                //发送给在线的会员   --只弹出消息
                state.connection.on("SendToOnlineMember", (content) => {
                    console.log('在线会员消息来了');
                    commit('changeMsg', { content })
                })

                //发送给在线员工 
                state.connection.on("SendToOnlineStaff", (content) => {
                    console.log('在线员工消息来了');
                    commit('changeMsg', { content })
                })

                //发送给员工
                state.connection.on("SendToStaff", (userId, content) => {
                    console.log('所有员工消息来了');
                    commit('changeMsg', { userId, content })
                })
                //发送给系统   --只弹出消息
                state.connection.on("SendToSystem", (systemId, content) => {
                    console.log('系统消息来了');
                    commit('changeMsg', { systemId, content })
                })
                //发送给门店 
                state.connection.on("SendToShop", (shopId, content) => {
                    console.log('门店消息来了');
                    commit('changeMsg', { shopId, content })
                })

                //发送给公司  --只弹出消息
                state.connection.on("SendToCompany", (companyId, content) => {
                    console.log('公司消息来了');
                    commit('changeMsg', { companyId, content })
                })

                //开始连接
                state.connection
                    .start()
                    .then(res => {
                        console.log('连接成功', res);
                    })
                    .catch(err => {
                        console.log(err, '连接错误');
                    })
            }
            //判断token是否存在如果存在就启动连接ws 如果不存在就等一秒之后重试token是否存在  循环触发
            const recursion = () => {
                if (store.state.userInfo.token) {
                    initConnection()
                } else {
                    setTimeout(() => {
                        recursion()
                    }, 1000);
                }
            }
            recursion()

        },
        //断开ws连接
        disconnectSignalR({ dispatch, state, commit }, obj) {
            state.connection.off("SendToUsers") //取消对XXX事件的绑定
            state.connection.stop() //断开SignalR连接
            commit('changgeConnection', null)
        }
    },
};
